export default class DeviceDetectionUtils {
    static isMobileDevice() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }
    static isIOSMobileDevice() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    static isTouchDevice() {
        return (('ontouchstart' in window) && this.isMobileDevice());
    }
}
//# sourceMappingURL=DeviceDetectionUtils.js.map